import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getNotePayableDetails, clearError, clearSuccess, clearNotePayableDetails } from '../../../../redux/Slices/authSlice';

// note payable details component
const NotePayableDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { notePayableDetails, isLoading, error, success } = useSelector((s) => s.auth);

  useEffect(() => {
    dispatch(getNotePayableDetails(id));
    return () => {
      dispatch(clearNotePayableDetails());
    };
  }, [dispatch, id]);

  const np = notePayableDetails || {};

  return (
    <div style={{ padding: '30px', backgroundColor: '#14263b', minHeight: 'calc(100vh - 80px)', color: 'white' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ margin: 0, fontSize: '20px' }}>تفاصيل ورقة الدفع</h1>
        <button
          onClick={() => navigate('/notes-payable')}
          style={{ background: '#444', color: 'white', border: 'none', borderRadius: 6, padding: '8px 12px', cursor: 'pointer' }}
        >
          رجوع
        </button>
      </div>

      <div style={{ background: '#1b3350', border: '1px solid #333', borderRadius: 12, padding: 24, marginBottom: 16 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>المورد:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.vendor?.name_ar || np.vendor?.name || np.vendor_name || '—'}</span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>رقم الورقة:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.note_number || '—'}</span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>القيمة:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.amount != null ? Number(np.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—'}</span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>الحالة:</strong>
            <span style={{ display: 'block' }}>
              {(() => {
                const s = String(np.status || '').toLowerCase();
                const map = {
                  paid: { text: 'مدفوع', bg: '#198754' },
                  unpaid: { text: 'غير مدفوع', bg: '#ffc107', color: '#000' },
                  canceled: { text: 'ملغي', bg: '#dc3545' },
                };
                const meta = map[s] || { text: np.status || '—', bg: '#6c757d' };
                return (
                  <span style={{ backgroundColor: meta.bg, color: meta.color || 'white', padding: '4px 10px', borderRadius: 16, fontSize: 12, fontWeight: 'bold', display: 'inline-block', whiteSpace: 'nowrap', direction: 'rtl' }}>
                    {meta.text}
                  </span>
                );
              })()}
            </span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>تاريخ الإصدار:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.issue_date ? String(np.issue_date).split('T')[0] : '—'}</span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>تاريخ الاستحقاق:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.due_date ? String(np.due_date).split('T')[0] : '—'}</span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>قيد اليومية:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.journal_entry_id || '—'}</span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>قيد دفع الورقة:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.payment_journal_entry_id || '—'}</span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>أنشئت بواسطة:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.creator?.name || '—'}</span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>تاريخ الإنشاء:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.created_at ? String(np.created_at).split('T')[0] : '—'}</span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>تاريخ التحديث:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.updated_at ? String(np.updated_at).split('T')[0] : '—'}</span>
          </div>
          <div style={{ gridColumn: '1 / -1', padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>الوصف:</strong>
            <span style={{ display: 'block', color: 'white' }}>{np.description || '—'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotePayableDetails;

